import { Label } from '@/components/ui/label';
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center h-full gap-10">
      <div className="flex flex-col items-center justify-center gap-2">
        <Label className="text-8xl font-bold">
          {t('not_found.title.translation')}
        </Label>
        <Label className="text-foreground text-2xl font-bold">
          {t('not_found.heading.translation')}
        </Label>
        <Label className="mt-4 text-muted-foreground">
          {t('not_found.description.translation')}
        </Label>
      </div>

      <Link to="/home">
        <Button variant="link" className="text-lg gap-2">
          {t('not_found.action.translation')}
          <ChevronRight className="w-4 h-4" />
        </Button>
      </Link>
    </div>
  );
};

export default NotFound;
